import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["name", "value", "onFocusin", "onFocusout", "onKeydown"]

import {
  reactive,
  computed,
  watch,
  ref, nextTick,
} from 'vue';

import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';

declare interface IoDate {
  format: (format: string) => string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DateField',
  props: {
  value: {
    type: [String, Number, Date],
    default: () => null,
  },
  name: {
    type: String,
    required: false,
  },
  minDate: {
    type: [String, Number, Date],
    default: () => null,
  },
  maxDate: {
    type: [String, Number, Date],
    default: () => null,
  },
  disableWeekend: {
    type: Boolean,
    required: false,
    default: () => false,
  },
},
  emits: ['input'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const datepicker = ref();
let defaultValue = null as Date | null;
if (props.value !== null && props.value !== '') {
  defaultValue = new Date(props.value);
}

const input = ref();

const onFocus = () => {
  if (input.value) {
    input.value.focus();
    nextTick(() => {
      datepicker.value.hidePopover();
      setTimeout(datepicker.value.showPopover, 1);
    });
  }
};

const field = reactive({
  date: defaultValue,
  dateText: '',
  attributes: [{
    timezone: 'Europe/Amsterdam',
  }],
  locale: 'de',
});

const formattedDateValue = computed(() => {
  const date = field.date as unknown as IoDate;

  return field.date !== null ? date.format('Y-m-d') : null;
});

const emitInput = () => emit('input', formattedDateValue.value);

watch(() => field.date, () => {
  emitInput();
});

const onInputKeyDown = (event: KeyboardEvent, callback: unknown) => {
  if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.'].indexOf(event.key) >= 0) {
    if (typeof callback === 'function') {
      callback();
    }
  }
};

const getDatepickerInputDate = (value: string) => {
  const datePartials = value.split('.');
  const validDateValue = datePartials.length === 3
      && (datePartials[0].length === 1 || datePartials[0].length === 2)
      && (datePartials[1].length === 1 || datePartials[1].length === 2)
      && datePartials[2].length === 4;

  if (validDateValue) {
    return new Date(
      parseInt(datePartials[2], 10),
      parseInt(datePartials[1], 10) - 1,
      parseInt(datePartials[0], 10),
    );
  }

  return null;
};

const updateValueByInput = (e: {
  target: {
    value: string,
  }
}) => {
  const inputDate = getDatepickerInputDate(e.target.value);

  if (datepicker.value && inputDate !== null) {
    datepicker.value.updateValue(inputDate);
    datepicker.value.move(inputDate);
    datepicker.value.hidePopover();
  }
};

const disabledDates = computed(() => {
  if (props.disableWeekend) {
    return {
      weekdays: [
        1,
        7,
      ],
    };
  }

  return null;
});

__expose({
  onFocus,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DatePicker), {
    ref_key: "datepicker",
    ref: datepicker,
    modelValue: field.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((field.date) = $event)),
    attributes: field.attributes,
    locale: field.locale,
    "max-date": __props.maxDate,
    "min-date": __props.minDate,
    "disabled-dates": disabledDates.value,
    "update-on-input": false
  }, {
    default: _withCtx(({ inputValue, hidePopover, showPopover }) => [
      _createElementVNode("input", {
        ref_key: "input",
        ref: input,
        name: __props.name,
        value: inputValue,
        "max-length": "10",
        onFocusin: showPopover,
        onFocusout: hidePopover,
        onKeydown: ($event: any) => (onInputKeyDown($event, showPopover)),
        onKeyup: updateValueByInput
      }, null, 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue", "attributes", "locale", "max-date", "min-date", "disabled-dates"]))
}
}

})